// Client Feedback API Service
const STRAPI_BASE_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || "http://localhost:1337";

export const clientFeedbackService = {
  // Get client feedback data
  getClientFeedback: async () => {
    try {
      // Use deep populate to get the clientImage data
      const response = await fetch(`${STRAPI_BASE_URL}/api/client-feedback?populate[clientMessage][populate]=*`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      return {
        success: true,
        data: data.data || data
      };
    } catch (error) {
      console.error('Error fetching client feedback:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

// Format client feedback data for testimonials component
export const formatClientFeedbackData = (feedbackData) => {
  if (!feedbackData || !feedbackData.clientMessage) {
    return [];
  }

  // Helper function to clean repeated text
  const cleanRepeatedText = (text) => {
    if (!text) return '';
    
    // Remove excessive repetition by finding the first meaningful sentence
    // and avoiding duplicated content
    const sentences = text.split('.').filter(s => s.trim().length > 10);
    
    if (sentences.length === 0) return text.substring(0, 200);
    
    // Take the first complete sentence and ensure it's not too long
    let cleanText = sentences[0].trim() + '.';
    
    // If the text is still too long, truncate it
    if (cleanText.length > 300) {
      cleanText = cleanText.substring(0, 297) + '...';
    }
    
    return cleanText;
  };

  const formatted = feedbackData.clientMessage.map((feedback, index) => ({
    id: index + 1,
    text: cleanRepeatedText(feedback.clientMessage) || 'Great service and support!',
    author: feedback.clientName || 'Anonymous',
    avatars: feedback.clientImage?.url ? [
      `${STRAPI_BASE_URL}${feedback.clientImage.url}`
    ] : [
      "https://bit.ly/dan-abramov" // fallback avatar
    ]
  }));
  
  return formatted;
};
